import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FontSizeDownGlyph = /*#__PURE__*/createElement("g", {
  id: "font_size_down",
  transform: "scale(2.5)"
}, /*#__PURE__*/createElement("path", {
  d: "M11.357 18.76L12.797 23H14.657L10.057 9.52H7.95695L3.37695 23H5.17695L6.57695 18.76H11.357ZM6.93695 17.4L8.25695 13.5C8.51695 12.68 8.73695 11.86 8.93695 11.06H8.97695C9.17695 11.84 9.37695 12.64 9.67695 13.52L10.997 17.4H6.93695Z"
}), /*#__PURE__*/createElement("path", {
  d: "M18.1814 -3.41764e-07C17.9917 -3.50053e-07 17.94 0.103439 18.0779 0.241359L21.7155 3.91346C21.8535 4.05138 22.0603 4.05138 22.1983 3.91346L25.9221 0.241359C26.06 0.10344 26.0083 3.6185e-10 25.8186 -7.92753e-09L18.1814 -3.41764e-07Z"
}));
const FontSizeDown = createSvg({
  name: 'fontSizeDown',
  path: FontSizeDownGlyph
});

export default FontSizeDown;
export { FontSizeDownGlyph };
